import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, IconButton, Typography, Chip } from '@material-ui/core';
import { Table, TableHead, TableRow, TableCell, TableBody, Checkbox, TableSortLabel, FormControl, InputLabel, Select } from '@material-ui/core';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';
import { TablePagination } from '@material-ui/core';
import TuneOutlined from '@material-ui/icons/TuneOutlined';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ShareIcon from '@material-ui/icons/Share';
import ReplayIcon from '@material-ui/icons/Replay';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import CheckIcon from '@material-ui/icons/Check';
import DocuwareTemplateService from '../../services/DocuwareTemplateService';
import ShareModal from './ShareModal';
import RecycleBinModal from './RecycleBinModal';
import notify from '../../utils/notifier';
import { hasPrivilege } from "../../utils/privileges_utility";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Paper,
  Fade,
  Switch,
  FormControlLabel,
  Drawer,
  Divider,
  InputAdornment
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import MoveIcon from "@material-ui/icons/Folder";
import PDFViewer from "./Staging/PDFViewer";
import vectorImage from "../../images/vector.png";
import dragonIcon from "../../icons/dragonIcon.svg";
import lockIcon from "../../icons/lockIcon.svg";
import crossIcon from "../../icons/crossIcon.svg";
import sortingIcon from "../../icons/sortingIcon.svg";
import InfoIcon from '@material-ui/icons/Info';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useHistory } from "react-router-dom";
import {NUMBER_OF_FILES_ALLOWED_FOR_RETRY} from '../../utils/constants.js'

function formatDocName(doc) {
  return doc
    .split(/[_\s]+/)        // split on "_" or spaces (one or more)
    .map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ');
}


const useStyles = makeStyles(theme => ({
  sortLabel: {
    color: "#00445D", // default color
    width: '100%',
    "&:hover": {
      color: "#0077b6", // hover color
    },
    "&.MuiTableSortLabel-root": {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
  },

  sortLabelActive: {
    fontWeight: "bold",   // bold active column
    color: "#005B96 !important", // highlight active column
  },

  sortIcon: {
    color: "#005B96 !important", // arrow color
    marginLeft: 'auto !important',
    marginRight: 0,
    flexShrink: 0,
    '& img': {
      width: '10px',
      height: '12px',
    },
  },

  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(0),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),

    borderTop: "1px solid #E0E0E0",
    borderBottom: "1px solid #E0E0E0",
    backgroundColor: "white",
  },
  toggleGroup: {
    "& .MuiToggleButton-root": {
      border: "1px solid #E0E0E0",
      borderRadius: "20px !important",
      textTransform: "none",
      padding: theme.spacing(0.5, 2.5),
      color: "#333",
      fontWeight: 500,
      marginLeft: '5px',
      "&.Mui-selected": {
        backgroundColor: "#005B96",
        color: "#fff",
        fontWeight: "bold",
        border: "1px solid #005B96",
      }
    },
  },

  stickyActionCell: {
    position: "sticky",
    right: 0,
    background: "#fff",
    zIndex: 2,
    borderLeft: "1px solid #e0e0e0",
  },
  stickyHeaderCell: {
    position: "sticky",
    right: 0,
    background: "#f9f9f9",
    zIndex: 3,
  },

  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },

  boldCell: {
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#00445D',
    textAlign: 'left',
    paddingTop: 0.5,
    paddingBottom: 0.5,
    '& .MuiTableSortLabel-root': {
      width: '100%',
    },
  },

  cell: {
    fontSize: '14px',
    color: '#1E1450',
    textAlign: 'left',
    paddingTop: 0.5, paddingBottom: 0.5
  },
  locationLink: {
    color: "#1E5EAA",
    textDecoration: "underline",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 500,
    "&:hover": {
      opacity: 0.9
    }
  },

  whiteRow: {
    backgroundColor: '#fff',
    height: '30px'
  },

  coloredRow: {
    backgroundColor: '#F9FCFF',
    height: '30px'
  },

  table: {
    '& .MuiTableRow-root': {
      height: '40px',
    }
  },

  iconButton: {
    height: '22px',
    width: '22px',
    marginRight: '5px',
    color: '#000'
  },

  actionButton: {
    height: '15px',
    width: '15px',
    marginRight: '2px',
    color: '#000'
  },

  iconButtonIcon: {
    fontSize: '20px'
  },

  controlContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },

  checkBox: {
    padding: 0,             // remove extra padding
    verticalAlign: 'middle' // ensure alignment

  },

  title: {
    fontFamily: 'PilatWideHeavy',
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '32px'
  },

  fieldName: {
    fontFamily: 'PilatWideHeavy',
    textTransform: 'none',
    fontWeight: 'bold'
  },

  drawerPaper: {
    width: 1046,
    padding: 0,
    borderRadius: 0,
    boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.2)',
  },

  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    height: 60,
    minHeight: 60,
    backgroundColor: '#FFFFFF',
  },

  drawerTitle: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '24px',
    color: '#0F0F19',
  },
  drawerCloseButton: {
    width: 36,
    height: 36,
    padding: 8,
    borderRadius: 24,
    color: '#00445D',
  },

  drawerContent: {
    display: 'flex',
    flex: 1,
    padding: '24px',
    gap: '8px',
    overflow: 'hidden',
    backgroundColor: '#F5F3F5',
  },

  panel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF',
    minWidth: 479,
    padding: '16px',
    gap: '12px',
  },

  panelHeader: {
    padding: 0,
    backgroundColor: '#FFFFFF',
  },

  panelTitleLeft: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '21px',
    color: '#00445D',
    fontFamily: 'Montserrat, sans-serif',
  },


  panelTitleRight: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '21px',
    color: '#00445D',
    fontFamily: 'Montserrat, sans-serif',
  },

  panelInstructions: {
    fontSize: '12px',
    lineHeight: '10px',
    color: '#6E6E72',
    fontFamily: 'Montserrat, sans-serif',
    padding: '0px',
  },

  searchContainer: {
    padding: 0,
    backgroundColor: '#FFFFFF',
    color: '#B6B6B9',
  },

  searchField: {
    width: '100%',
    fontFamily: 'Montserrat, sans-serif',
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      minHeight: 32,
      height: 32,
      border: '1px solid #B6B6B9',
      fontFamily: 'Montserrat, sans-serif',
      '& fieldset': {
        border: 'none',
      },
    },
    '& .MuiInputBase-input': {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: 14,
      lineHeight: '12px',
      color: '#6E6E72',
      padding: '10px 0px',
    },
  },

  columnList: {
    flex: 1,
    overflowY: 'auto',
    padding: 0,
  },

  columnItem: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 28,
    height: 28,
    padding: '6px 12px',
    marginBottom: 4,
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    cursor: 'grab',
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.12)',
    border: '1px solid transparent',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:active': {
      cursor: 'grabbing',
    },
  },
  availableColumnItem: {
    '&:hover': {
      borderColor: '#0080AF',
      backgroundColor: '#FFFFFF',
    },
  },
  inUseColumnItem: {
    '&:hover': {
      backgroundColor: '#F5F3F5',
      borderColor: 'transparent',
    },
  },
  lockedColumnItem: {
    backgroundColor: '#F5F3F5',
    '& $columnName': {
      color: '#6E6E72',
    },
    '& $dragHandle img': {
      opacity: 0.5,
    },
  },

  dragHandle: {
    marginRight: 12,
    cursor: 'grab',
    display: 'flex',
    alignItems: 'center',
    '&:active': {
      cursor: 'grabbing',
    },
    '& img': {
      width: '20px',
      height: '20px',
    },
  },

  columnName: {
    flex: 1,
    fontSize: '12px',
    lineHeight: '10px',
    color: '#3A3A42',
    fontFamily: 'Montserrat, sans-serif',
  },

  lockIcon: {
    marginLeft: 12,
    display: 'flex',
    alignItems: 'center',
    marginRight: 0,
    '& img': {
      width: '20px',
      height: '20px',
    },
  },

  removeIcon: {
    cursor: 'pointer',
    padding: 0,
    '&:hover': {
      opacity: 0.7,
    },
    '& img': {
      width: '18px',
      height: '18px',
    },
  },
  draggingColumnItem: {
    borderColor: '#0080AF',
    backgroundColor: '#F5F3F5',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.16)',
  },

  transferButtons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    minWidth: 24,
  },

  transferImage: {
    height: 'auto',
    cursor: 'pointer',
    userSelect: 'none',
  },

  drawerFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 16px',
    height: 60,
    minHeight: 60,
    boxShadow: '0px -1px 4px rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
    marginTop: 'auto',
  },

  drawerContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    fontFamily: '"Montserrat", sans-serif !important',
    '& *': {
      fontFamily: '"Montserrat", sans-serif !important',
    },
  },

  searchIcon: {
    color: '#B6B6B9',
  },

  emptyStateText: {
    padding: theme.spacing(2),
    color: '#999',
    textAlign: 'center',
    fontFamily: 'Montserrat, sans-serif',
  },

  footerButtonContainer: {
    display: 'flex',
    gap: 8,
  },

  drawerButton: {
    fontFamily: '"Montserrat", sans-serif !important',
    textTransform: 'capitalize',
    borderRadius: 100,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: '14px',
    height: 36,
    minHeight: 36,
    padding: '10px 16px',
    transition: 'all 0.2s ease',
  },
  // Save View button - Primary filled
  saveButton: {
    width: 97,
    backgroundColor: '#00445D',
    color: '#FFFFFF',
    border: '1px solid #00445D',
    '&:hover': {
      backgroundColor: '#0080AF',
    },
    '&:focus': {
      outline: 'none',
      backgroundColor: '#00445D',
      border: '3px solid #EBEBF0',
    },
    '&:active': {
      backgroundColor: '#0E6A8C',
      borderColor: '#0E6A8C',
    },
    '&.Mui-disabled': {
      backgroundColor: '#B6B6B9',
      borderColor: '#B6B6B9',
      color: '#FFFFFF',
      opacity: 1,
    },
  },
  // Reset button - Outlined
  resetButton: {
    width: 68,
    backgroundColor: '#FFFFFF',
    color: '#00445D',
    border: '1px solid #00445D',
    '&:hover': {
      backgroundColor: '#E3F2FD',
      borderColor: '#00445D',
    },
    '&:focus': {
      outline: 'none',
      backgroundColor: '#FFFFFF',
      border: '2px solid #D5D5DD',
    },
    '&:active': {
      backgroundColor: '#99CCDF',
      borderColor: '#00445D',
    },
    '&.Mui-disabled': {
      backgroundColor: '#FFFFFF',
      borderColor: '#B6B6B9',
      color: '#B6B6B9',
      opacity: 1,
    },
  },
  // Cancel button - Text only
  cancelButton: {
    width: 67,
    backgroundColor: 'transparent',
    color: '#00445D',
    border: '1px solid transparent',
    '&:hover': {
      backgroundColor: '#E3F2FD',
      border: '1px solid transparent',
    },
    '&:focus': {
      outline: 'none',
      backgroundColor: 'transparent',
      border: '2px solid #D5D5DD',
    },
    '&.Mui-disabled': {
      color: '#B6B6B9',
      backgroundColor: 'transparent',
      border: '1px solid transparent',
      opacity: 1,
    },
  },

  // Document Preview Modal Styles
  splitViewContainer: {
    display: 'flex',
    height: '70vh',
    gap: theme.spacing(2),
  },
  documentPreviewPane: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: '#f5f5f5',
    border: '1px solid #e0e0e0',
  },
  documentPreviewHeader: {
    padding: theme.spacing(1.5),
    backgroundColor: '#fff',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  documentPreviewTitle: {
    fontWeight: 600,
    fontSize: '14px',
    color: '#00445D',
  },
  documentPreviewContent: {
    flex: 1,
    overflow: 'auto',
    backgroundColor: '#f0f0f0',
  },
  formPane: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  formPaneHeader: {
    padding: theme.spacing(1.5),
    backgroundColor: '#fff',
    borderBottom: '1px solid #e0e0e0',
    borderRadius: '8px 8px 0 0',
  },
  formPaneTitle: {
    fontWeight: 600,
    fontSize: '14px',
    color: '#00445D',
  },
  formPaneContent: {
    flex: 1,
    overflow: 'auto',
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: '0 0 8px 8px',
    border: '1px solid #e0e0e0',
    borderTop: 'none',
  },
  previewToggleButton: {
    minWidth: 'auto',
    padding: '4px 8px',
    fontSize: '12px',
  },
  selectAllCheckBox: {
    marginLeft: "-4px",
  }
}));

// Custom Sort Icon Component for TableSortLabel
const CustomSortIcon = React.forwardRef((props, ref) => {
  const { direction } = props;
  return (
    <span ref={ref} style={{ display: 'inline-flex', alignItems: 'right' }}>
      <img
        src={sortingIcon}
        alt="Sort"
        style={{
          width: '10px',
          height: '12px',
          transform: direction === 'desc' ? 'rotate(180deg)' : 'none',
          transition: 'transform 0.2s'
        }}
      />
    </span>
  );
});
CustomSortIcon.displayName = 'CustomSortIcon';

const userPrefs = {
  rowsPerPageOptions: [10, 25, 100]
};

const systemFields = [
  "id",
  "name",
  "location",
  "staging_reason",
  "document_category",
  "dw_id",
  "dw_section_count",
  "total_pages",
  "extension",
  "doc_size",
  "store_user",
  "store_datetime",
  "mod_user",
  "mod_datetime",
  "last_access_user",
  "last_access_datetime",
  "dw_doc_guid",
  "doc_type",
  "file_identifier",
  "file_path",
  "created_at",
  "updated_at",
  "access_type",
  "owner_client",
  "format"
];

function toTitleCase(key) {
  return key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\w\S*/g, (w) =>
      w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
    );
}

// Staging cause configuration
const STAGING_CAUSE_CONFIG = {
  malicious: {
    label: "Malicious File",
    chipColor: "#FFFFFF",
    textColor: "#0F0F19",
    actions: ["keep", "delete"]
  },
  duplicate_content: {
    label: "Duplicate Content",
    chipColor: "#FFFFFF",
    textColor: "#0F0F19",
    actions: ["keep", "delete"]
  },
  same_file_name: {
    label: "Same File Name",
    chipColor: "#FFFFFF",
    textColor: "#0F0F19",
    actions: ["rename", "delete"]
  },
  folder_conflict: {
    label: "Folder Conflict",
    chipColor: "#FFFFFF",
    textColor: "#0F0F19",
    actions: ["move_to_folder", "delete"]
  },
  poor_indexing: {
    label: "Poor Indexing",
    chipColor: "#FFF3E0",
    textColor: "#E65100",
    actions: ["manual_entry", "delete"]
  },
  pending_categorization: {
    label: "Pending Categorization",
    chipColor: "#FFFFFF",
    textColor: "#0F0F19",
    actions: ["delete"]
  },
  poor_classification: {
    label: "Classification Failed",
    chipColor: "#FFEBEE",
    textColor: "#C62828",
    actions: ["manual_classify", "delete"]
  },
  poor_extraction: {
    label: "Extraction Failed",
    chipColor: "#FFF3E0",
    textColor: "#E65100",
    actions: ["manual_entry", "delete"]
  }
};

// Helper function to get allowed actions based on staging cause
const getActionsForRow = (row) => {
  const causeType = row.staging_reason;

  if (causeType && STAGING_CAUSE_CONFIG[causeType]) {
    return STAGING_CAUSE_CONFIG[causeType].actions;
  }

  // Default actions when no staging cause (null case)
  return ["keep", "delete"];
};

// Custom column labels (override toTitleCase for specific fields)
const customColumnLabels = {
  "staging_reason": "Staging Cause",
  "location": "Location",
  "document_category": "Category"
};

const sortableKeys = ["id", "name", "created_at", "updated_at", "doc_type", "doc_size", "store_datetime", "last_access_datetime", "mod_datetime"];
const defaultView = ["id", "name", "document_category", "created_at", "doc_type", "doc_size", "status", "invoice_no", "trip_sheet_no", "customer_order_no"];
const filterKeys = ["id", "name", "extension", "documentType", "fileIdentifier"];

const filterFormValues = {
  "extension": [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".csv", ".txt", ".jpg", ".jpeg", ".png", ".gif", ".bmp", ".tiff", ".webp", ".svg", ".mp3", ".wav", ".ogg", ".aac", ".flac"],
  "documentType": ['abc', 'adddd']
}

const downloadFiles = async (selectedDocuments, setBackdrop) => {
  for (const [id, name] of selectedDocuments) {
    try {
      setBackdrop(true);
      const response = await DocuwareTemplateService.viewDocument(id);

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      let fileName = name && name.trim() ? name : String(id);
      const safeName = fileName.replace(/[\\/:*?"<>|]/g, "_");
      const hasExtension = /\.[a-zA-Z0-9]+$/.test(safeName);

      link.download = hasExtension ? safeName : `${safeName}.pdf`;

      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(`Failed to download document ${id}:`, error);
      notify({
        type: 'error',
        message: `Error downloading ${name || id}`
      });
    } finally {
      setBackdrop(false);
    }
  }
};


const DocumentTabularView = (
  {
    rows,
    onDocumentClick,
    circularBackdrop,
    orderBy,
    order,
    queryCount,
    page,
    handleChangePage,
    rowsPerPage,
    handleChangeRowsPerPage,
    handleMultipleFileSelect,
    selectedDocuments,
    selectedDocumentsFileId,
    setBackdrop,
    clientFields,
    handleRequestSort,
    handleFilterSearch,
    documentTypes,
    currentCompany,
    allDocumentTypes,
    isStaging = false,
    showStagingCause = false,
    showLocationColumn = false
  }) => {
  const classes = useStyles();
  const history = useHistory();

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedActionRow, setSelectedActionRow] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [documentDetails, setDocumentDetails] = useState(null);
  const [showSystemFields, setShowSystemFields] = useState(false);
  const [manageColumnsOpen, setManageColumnsOpen] = useState(false);
  const [manageColumnsState, setManageColumnsState] = useState({});
  const [columns, setColumns] = useState([]);
  const [availableColumns, setAvailableColumns] = useState([]);
  const [inUseColumns, setInUseColumns] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const mandatoryColumns = ['name']; // Columns that cannot be removed
  
  // Storage key for persisting column preferences
  const columnStorageKey = `docuware_columns_${showStagingCause ? 'staging' : 'default'}`;
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [filters, setFilters] = useState({});
  const handleFilterOpen = () => setFilterDialogOpen(true);
  const handleFilterClose = () => setFilterDialogOpen(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [view, setView] = useState("all");
  const [anchorElTop, setAnchorElTop] = useState(null);
  const [bulkAnchorEl, setBulkAnchorElTop] = useState(null);
  const [disabledMenu, setDisabledMenu] = useState(true);
  const [moveModalOpen, setMoveModalOpen] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState("");
  const [moveLoading, setMoveLoading] = useState(false);
  
  // Manual entry modal states
  const [manualEntryOpen, setManualEntryOpen] = useState(false);
  const [manualClassifyOpen, setManualClassifyOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [manualLoading, setManualLoading] = useState(false);

  // Check user privileges
  const canEdit = hasPrivilege("DS_FILE_EDIT");
  const canMove = hasPrivilege("DS_FILE_MOVE");
  const canShare = hasPrivilege("DS_FILE_SHARE");
  const canUpload = hasPrivilege("DS_FILE_UPLOAD");
  const canDelete = hasPrivilege("DS_RECYC_DLT");


  const handleBulkMenuClick = (event) => {
    setBulkAnchorElTop(event.currentTarget);
  };

  const handleBulkMenuClose = () => {
    setBulkAnchorElTop(null);
  };

  const handleTopMenuClick = (event) => {
    setAnchorElTop(event.currentTarget);
  };

  const handleTopMenuClose = () => {
    setAnchorElTop(null);
  };

  const isValidDateString = (value) => {
    if (typeof value !== 'string') return false;
  
    const date = new Date(value);
    return !isNaN(date.getTime()) && value.includes('T');
  };

  const formatDate = (value) => {
    const date = new Date(value);
    if (isNaN(date.getTime())) return value;
  
    let formatted =  date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    return formatted.replace(/am|pm/i, (match) => match.toUpperCase());
  };
  

  const renderValue = (value) => {
    if (isValidDateString(value)) {
      return formatDate(value);
    }
    return value;
  };

  const getRowLocationLabel = (row) => {
    const folderName = String(row?.folder_name || "").trim();
    if (!folderName) {
      return "-";
    }
    if (folderName.toLowerCase() === "other") {
      return "Staging";
    }
    return formatDocName(folderName);
  };

  const handleLocationNavigation = (event, row) => {
    event.stopPropagation();
    const folderName = String(row?.folder_name || "").trim();
    if (!folderName) {
      return;
    }

    if (folderName.toLowerCase() === "other") {
      history.push("/document-suite?tab=staging");
      return;
    }

    history.push(`/document-suite?tab=folders&folder=${encodeURIComponent(folderName)}`);
  };



  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      let currFilters = filters;
      if (newView === 'my') {
        currFilters['_accessType'] = 'owned';
      }
      else if (newView == 'shared') {
        currFilters['_accessType'] = 'shared';

      }
      else if (newView == 'all') {
        delete currFilters['_accessType'];
      }
      setView(newView);
      setFilters(currFilters)
      handleFilterSearch(currFilters);
    }
  };

  const handleFilterChange = (id, value) => {
    if (value && value != '') {
      setFilters((prev) => ({ ...prev, [id]: value }));
    }
  };

  const handleShareClick = () => {
    setShareOpen(true);
    handleMenuClose();

  };

  const handleDeleteClick = () => {
    setDeleteOpen(true);
    handleMenuClose();
  };

  const handleRetryClick = async () => {
    const fileIdentifierIdMap = new Map();
    (rows || []).forEach((row) => {
        fileIdentifierIdMap.set(row.file_identifier, row.id);
    });

    const fileIdentifiers = selectedDocumentsFileId
        ? Array.from(selectedDocumentsFileId)
        : [];

    const noOfFileSelected = fileIdentifiers.length;

    if (noOfFileSelected > NUMBER_OF_FILES_ALLOWED_FOR_RETRY) {
        notify({
            type: "error",
            message: `You can only send at max ${NUMBER_OF_FILES_ALLOWED_FOR_RETRY} for retry at a time`
        });
        return;
    }

    if (noOfFileSelected === 0) {
        notify({
            type: "error",
            message: "Please select at least one file to retry"
        });
        return;
    }

    try {
        const response = await DocuwareTemplateService.retryFiles(fileIdentifiers);

        const summary = response?.data?.summary;
        const results = response?.data?.results;

        if (
            !summary ||
            typeof summary.successful !== "number" ||
            typeof summary.failed !== "number"
        ) {
            notify({
                type: "error",
                message: "Invalid response received from retry request"
            });
            return;
        }

        const failedFileIds = (Array.isArray(results?.failed) ? results.failed : [])
            .map((file) => {
                  const fileIdentifier = file?.fileIdentifier;

                  return (
                      fileIdentifierIdMap.get(fileIdentifier) ||
                      fileIdentifier ||
                      "Unknown file"
                  );
            });
        if (summary.failed === 0) {
            notify({
                type: "success",
                message: `Successfully queued ${summary.successful} file${summary.successful !== 1 ? "s" : ""} for retry`
            });
        } 
        else if (summary.successful > 0) {
            notify({
                type: "success",
                message: `Successfully queued ${summary.successful} file${summary.successful !== 1 ? "s" : ""} for retry`
            });

            notify({
                type: "error",
                message: (
                    <div>
                        <div>
                            Failed to queue {summary.failed} file
                            {summary.failed !== 1 ? "s" : ""} for retry:
                        </div>

                        <ul style={{ margin: "8px 0 0 20px", padding: 0 }}>
                            {failedFileIds.map((fileId, index) => (
                                <li key={index}>{fileId}</li>
                            ))}
                        </ul>
                    </div>
                )
            });

        } 
        else {
          notify({
              type: "error",
              message: (
                  <div>
                      <div>
                          Failed to queue {summary.failed} file
                          {summary.failed !== 1 ? "s" : ""} for retry:
                      </div>

                      <ul style={{ margin: "8px 0 0 20px", padding: 0 }}>
                          {failedFileIds.map((fileId, index) => (
                              <li key={index}>{fileId}</li>
                          ))}
                      </ul>
                  </div>
              )
          });

        }
    } catch (error) {
        console.error("Retry API error:", error);

        notify({
            type: "error",
            message: "Failed to process retry request"
        });
        return;
    }
    try {
        refreshPage();
        handleBulkMenuClose();
    } catch (error) {
        console.error("Post-retry UI error:", error);
        return;
    }    
  };  

  const handleFilterApply = () => {
    handleFilterSearch(filters);
    setFilterDialogOpen(false);
  };

  useEffect(() => {
    let columnValues = [];
    for (let column of systemFields) {
      if (column === "location" && !showLocationColumn) {
        continue;
      }
      let columnValue = {};
      columnValue['id'] = column;
      columnValue['label'] = customColumnLabels[column] || toTitleCase(column);
      columnValue['sortable'] = sortableKeys.includes(column);
      columnValues.push({ ...columnValue });
    }
    if (clientFields) {
      for (let column of clientFields) {
        let columnValue = {};
        columnValue['id'] = column.name;
        columnValue['label'] = toTitleCase(column.name);
        columnValue['sortable'] = sortableKeys.includes(column.name);
        columnValues.push({ ...columnValue });
      }
    }

    const shouldShowStagingCauseByDefault = isStaging || showStagingCause;
    const baseDefaultView = shouldShowStagingCauseByDefault
      ? ["id", "name", "staging_reason", "document_category", "created_at", "doc_type", "doc_size", "status", "invoice_no", "trip_sheet_no", "customer_order_no"]
      : defaultView;
    const dynamicDefaultView = showLocationColumn
      ? ["id", "name", "location", ...baseDefaultView.filter((column) => column !== "id" && column !== "name")]
      : baseDefaultView;

    // Try to load saved column preferences from localStorage
    let manageColumns = {};
    let savedInUseColumnIds = null;
    try {
      const savedConfig = localStorage.getItem(columnStorageKey);
      if (savedConfig) {
        const parsed = JSON.parse(savedConfig);
        savedInUseColumnIds = parsed.inUseColumnIds;
      }
    } catch (e) {
      console.warn('Failed to load saved column preferences:', e);
    }

    // If we have saved preferences, use them; otherwise use default view
    if (savedInUseColumnIds && Array.isArray(savedInUseColumnIds)) {
      for (let column of columnValues) {
        manageColumns[column.id] = savedInUseColumnIds.includes(column.id) || mandatoryColumns.includes(column.id);
      }
    } else {
      for (let column of columnValues) {
        manageColumns[column.id] = dynamicDefaultView.includes(column.id);
      }
    }
    
    setManageColumnsState(manageColumns);
    setColumns(columnValues);

    // Initialize available and in-use columns
    const inUse = columnValues.filter(col => manageColumns[col.id]);
    const available = columnValues.filter(col => !manageColumns[col.id]);
    
    // If we have saved column order, restore it; otherwise sort to put "name" first
    let sortedInUse;
    if (savedInUseColumnIds && Array.isArray(savedInUseColumnIds)) {
      // Restore saved order
      sortedInUse = savedInUseColumnIds
        .map(id => inUse.find(col => col.id === id))
        .filter(Boolean);
      // Add any new columns that weren't in saved config
      const savedIds = new Set(savedInUseColumnIds);
      const newColumns = inUse.filter(col => !savedIds.has(col.id));
      sortedInUse = [...sortedInUse, ...newColumns];
    } else {
      sortedInUse = inUse.find(col => col.id === 'name')
        ? [inUse.find(col => col.id === 'name'), ...inUse.filter(col => col.id !== 'name')]
        : inUse;
    }
    
    setInUseColumns(sortedInUse);
    setAvailableColumns(available);

    filterFormValues.documentType = documentTypes;

  }, [clientFields, isStaging, showStagingCause, showLocationColumn, columnStorageKey])

  useEffect(() => {
    handleFilterSearch(filters);
  }, [currentCompany])

  const handleToggleColumn = (col) => {
    setManageColumnsState((prev) => ({
      ...prev,
      [col]: !prev[col],
    }));
  };

  // Sort columns to put "name" first
  const sortInUseColumns = (cols) => {
    const nameColumn = cols.find(col => col.id === 'name');
    const otherColumns = cols.filter(col => col.id !== 'name');
    return nameColumn ? [nameColumn, ...otherColumns] : cols;
  };

  const buildDrawerColumnsFromState = (stateMap) => {
    const inUse = sortInUseColumns(
      columns.filter((col) => stateMap[col.id] || mandatoryColumns.includes(col.id))
    );
    const available = columns.filter(
      (col) => !stateMap[col.id] || mandatoryColumns.includes(col.id)
    );
    return { inUse, available };
  };

  // Initialize columns when drawer opens
  const handleManageColumnsOpen = () => {
    const { inUse, available } = buildDrawerColumnsFromState(manageColumnsState);
    setInUseColumns(inUse);
    setAvailableColumns(available);
    setSearchTerm('');
    setManageColumnsOpen(true);
  };

  const handleManageColumnsClose = () => {
    setManageColumnsOpen(false);
    setSearchTerm('');
    // Also close the top menu if it's open
    handleTopMenuClose();
  };

  // Move column from available to in-use
  const addColumnToInUse = (column) => {
    if (!mandatoryColumns.includes(column.id)) {
      setAvailableColumns(prev => prev.filter(col => col.id !== column.id));
    }
    setInUseColumns(prev =>
      prev.some((col) => col.id === column.id) ? prev : sortInUseColumns([...prev, column])
    );
  };

  // Remove column from in-use (move to available)
  const removeColumnFromInUse = (column) => {
    if (mandatoryColumns.includes(column.id)) {
      return; // Don't allow removing mandatory columns
    }
    setInUseColumns(prev => prev.filter(col => col.id !== column.id));
    setAvailableColumns(prev => [...prev, column]);
  };

  // Reset to default view
  const handleResetColumns = () => {
    const shouldShowStagingCauseByDefault = isStaging || showStagingCause;
    const baseDefaultView = shouldShowStagingCauseByDefault
      ? ["id", "name", "staging_reason", "document_category", "created_at", "doc_type", "doc_size", "status", "invoice_no", "trip_sheet_no", "customer_order_no"]
      : defaultView;
    const dynamicDefaultView = showLocationColumn
      ? ["id", "name", "location", ...baseDefaultView.filter((column) => column !== "id" && column !== "name")]
      : baseDefaultView;
    
    const resetState = {};
    columns.forEach(col => {
      resetState[col.id] = dynamicDefaultView.includes(col.id) || mandatoryColumns.includes(col.id);
    });
    const { inUse, available } = buildDrawerColumnsFromState(resetState);
    setInUseColumns(inUse);
    setAvailableColumns(available);
    
    // Clear saved column preferences from localStorage
    try {
      localStorage.removeItem(columnStorageKey);
    } catch (e) {
      console.warn('Failed to clear saved column preferences:', e);
    }

    // Close the top menu if it's open
    handleTopMenuClose();
  };

  // Save the current column configuration
  const handleSaveView = () => {
    const nextManageColumnsState = {};
    const inUseSet = new Set(inUseColumns.map((col) => col.id));
    columns.forEach((col) => {
      nextManageColumnsState[col.id] = inUseSet.has(col.id) || mandatoryColumns.includes(col.id);
    });
    setManageColumnsState(nextManageColumnsState);
    
    // Save column preferences to localStorage (including order)
    try {
      const configToSave = {
        inUseColumnIds: inUseColumns.map(col => col.id),
        savedAt: new Date().toISOString()
      };
      localStorage.setItem(columnStorageKey, JSON.stringify(configToSave));
    } catch (e) {
      console.warn('Failed to save column preferences:', e);
    }
    
    handleManageColumnsClose();
    // Also close the top menu if it's open
    handleTopMenuClose();
  };

  // Handle drag and drop
  const onDragEnd = (result) => {
    const { source, destination } = result;

    // Dropped outside a droppable area
    if (!destination) {
      return;
    }

    // Same position, no change needed
    if (source.droppableId === destination.droppableId && source.index === destination.index) {
      return;
    }

    // Get the source list based on search filtering
    const sourceAvailableList = source.droppableId === 'available' ? filteredAvailableColumns : availableColumns;

    // Moving within the same list
    if (source.droppableId === destination.droppableId) {
      if (source.droppableId === 'available') {
        // Reorder available columns (need to handle filtered list)
        const draggedColumn = sourceAvailableList[source.index];
        const newAvailable = Array.from(availableColumns);
        const actualSourceIndex = newAvailable.findIndex(col => col.id === draggedColumn.id);
        const [removed] = newAvailable.splice(actualSourceIndex, 1);
        // Find actual destination index
        const destColumn = sourceAvailableList[destination.index];
        const actualDestIndex = destColumn ? newAvailable.findIndex(col => col.id === destColumn.id) : newAvailable.length;
        newAvailable.splice(actualDestIndex >= 0 ? actualDestIndex : newAvailable.length, 0, removed);
        setAvailableColumns(newAvailable);
      } else if (source.droppableId === 'inUse') {
        // Reorder in-use columns
        const newInUse = Array.from(inUseColumns);
        const [removed] = newInUse.splice(source.index, 1);
        newInUse.splice(destination.index, 0, removed);
        setInUseColumns(newInUse);
      }
    } else {
      // Moving between lists
      if (source.droppableId === 'available' && destination.droppableId === 'inUse') {
        // Move from available to in-use
        const draggedColumn = sourceAvailableList[source.index];
        const newAvailable = mandatoryColumns.includes(draggedColumn.id)
          ? Array.from(availableColumns)
          : availableColumns.filter(col => col.id !== draggedColumn.id);
        const newInUse = Array.from(inUseColumns);
        if (!newInUse.some((col) => col.id === draggedColumn.id)) {
          newInUse.splice(destination.index, 0, draggedColumn);
        }
        setAvailableColumns(newAvailable);
        setInUseColumns(newInUse);
      } else if (source.droppableId === 'inUse' && destination.droppableId === 'available') {
        // Move from in-use to available (check if mandatory)
        const column = inUseColumns[source.index];
        if (mandatoryColumns.includes(column.id)) {
          return; // Don't allow removing mandatory columns
        }
        const newInUse = Array.from(inUseColumns);
        const [removed] = newInUse.splice(source.index, 1);
        const newAvailable = Array.from(availableColumns);
        newAvailable.splice(destination.index, 0, removed);
        setInUseColumns(newInUse);
        setAvailableColumns(newAvailable);
      }
    }
  };

  // Filter available columns by search term
  const filteredAvailableColumns = availableColumns.filter(col =>
    col.label.toLowerCase().includes(searchTerm.toLowerCase())
  );





  const handleEditClick = async () => {
    try {
      const response = await DocuwareTemplateService.fetchDocumentDetails(selectedActionRow.id);
      setDocumentDetails(response.data);
      setOpenEditModal(true);
      handleMenuClose();
    } catch (error) {
      console.error("Error fetching document details:", error);
      notify({ type: "error", message: "Failed to load document details" });
    }
  };

  // const handleMoveFolderClick = async () => {
  //   try {
  //     const response = await DocuwareTemplateService.moveToFolder(selectedActionRow.id);
  //     refreshPage();
  //   } catch (error) {
  //     console.error("Error while moving the document to folder", error);
  //     notify({ type: "error", message: "Error while moving the document to folder" + error });
  //   }
  // };

  const handleMoveFolderClick = () => {
    setSelectedDocType("");
    setMoveModalOpen(true);
    handleMenuClose();
  };

  const handleRenameClick = () => {
    // TODO: Implement rename functionality
    notify({ type: "info", message: "Rename functionality coming soon" });
    handleMenuClose();
  };

  const handleKeepClick = async () => {
    try {
      // TODO: Call API to mark file as kept/reviewed
      notify({ type: "success", message: "Document kept successfully" });
      refreshPage();
      handleMenuClose();
    } catch (error) {
      console.error("Keep failed", error);
      notify({ type: "error", message: "Failed to keep document" });
    }
  };

  const handleManualEntryClick = async () => {
    try {
      const response = await DocuwareTemplateService.fetchDocumentDetails(selectedActionRow.id);
      setDocumentDetails(response.data);
      setManualEntryOpen(true);
      handleMenuClose();
    } catch (error) {
      console.error("Error fetching document details:", error);
      notify({ type: "error", message: "Failed to load document details" });
    }
  };

  const handleManualClassifyClick = async () => {
    try {
      // Fetch categories for classification
      const catResponse = await DocuwareTemplateService.getCategories();
      const catData = catResponse?.data?.categories || catResponse?.data || [];
      setCategories(catData);
      setSelectedCategory(selectedActionRow?.document_category || "");
      setManualClassifyOpen(true);
      handleMenuClose();
    } catch (error) {
      console.error("Error fetching categories:", error);
      notify({ type: "error", message: "Failed to load categories" });
    }
  };

  const handleManualEntrySave = async () => {
    try {
      setManualLoading(true);
      
      // Only send client fields, mapping column_name back to field name
      let data = {};
      for (let field of clientFields) {
        const columnName = field.columnName || field.column_name;
        // documentDetails stores values by column_name, but API expects field.name
        if (documentDetails[columnName] !== undefined && documentDetails[columnName] !== null && documentDetails[columnName] !== '') {
          data[field.name] = documentDetails[columnName];
        }
      }
      
      console.log('Manual entry save - data to send:', data);
      
      await DocuwareTemplateService.updateMetadata({ data }, selectedActionRow.id);
      notify({ type: "success", message: "Fields updated successfully" });
      setManualEntryOpen(false);
      refreshPage();
    } catch (error) {
      console.error("Error updating fields:", error);
      notify({ type: "error", message: "Failed to update fields" });
    } finally {
      setManualLoading(false);
    }
  };

  const handleManualClassifySave = async () => {
    if (!selectedCategory) {
      notify({ type: "error", message: "Please select a category" });
      return;
    }
    
    try {
      setManualLoading(true);
      // Update document with manual classification
      await DocuwareTemplateService.updateMetadata({
        data: {
          document_category: selectedCategory,
          classification_status: 'manual'
        }
      }, selectedActionRow.id);
      notify({ type: "success", message: "Document classified successfully" });
      setManualClassifyOpen(false);
      refreshPage();
    } catch (error) {
      console.error("Error classifying document:", error);
      notify({ type: "error", message: "Failed to classify document" });
    } finally {
      setManualLoading(false);
    }
  };

  const handleConfirmMove = async () => {
    if (!selectedDocType) {
      notify({ type: "error", message: "Please select a document type" });
      return;
    }

    try {
      setMoveLoading(true);
      await DocuwareTemplateService.moveToFolderByName(
        selectedActionRow.id,
        selectedDocType
      );
      notify({ type: "success", message: "Document moved successfully" });
      setMoveModalOpen(false);
      refreshPage();
    } catch (error) {
      console.error("Move failed", error);
      notify({ type: "error", message: "Failed to move document" });
    } finally {
      setMoveLoading(false);
    }
  };



  const handleFieldChange = (field, value) => {
    setDocumentDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleEditClose = () => {
    setOpenEditModal(false);
  };

  const refreshPage = () => {
    handleFilterSearch(filters);
  }

  const handleEditSave = () => {

    let requestObj = {};

    let data = {};

    for (let field of clientFields) {
      data[field.name] = documentDetails[field.name];
    }
    requestObj.data = data;
    let id = selectedActionRow.id;

    DocuwareTemplateService.updateMetadata(requestObj, id).then(response => {

      notify({
        type: "success",
        message: "Successfully updated the document"
      });
    }).catch(error => {
      notify({
        type: 'error',
        message: 'Error updating the document'
      });
    });
    setOpenEditModal(false);

  };


  const handleMenuClick = (event, row) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedActionRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedActionRow(null);
  };

  const createNoTable = () => {
    let arr = [];
    arr.push(
      <TableRow key="no-records" style={{ height: '60px' }}>
        <TableCell colSpan="11" align="center" className={classes.noRecordsRow}>
          {circularBackdrop ? 'Fetching data, please wait' : 'No records found'}
        </TableCell>
      </TableRow>
    );
    return arr;
  };


  const pageRows = rows || [];
  const allPageSelected =
    pageRows.length > 0 &&
    pageRows.every((row) => selectedDocuments.has(row.id));

  const somePageSelected =
    pageRows.some((row) => selectedDocuments.has(row.id)) &&
    !allPageSelected;

  const handleSelectAllPage = (event) => {
    const checked = event.target.checked;

    pageRows.forEach((row) => {
      handleMultipleFileSelect(
        row.id,
        checked,
        row.file_identifier,
        row.name
      );
    });
  };


  return (
    <div className={classes.tableWrapper}>
      <Box className={classes.headerContainer}>
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={handleViewChange}
          className={classes.toggleGroup}
        >
          <ToggleButton value="all">All Documents</ToggleButton>
          <ToggleButton value="my">My Documents</ToggleButton>
          <ToggleButton value="shared">Shared With Me</ToggleButton>
        </ToggleButtonGroup>

        <Box className={classes.controlContainer}>



          {selectedDocuments && selectedDocuments.size >= 1 ? (
            // ✅ If some docs are selected → Show count + bulk actions
            <Box display="flex" alignItems="center" gap={2}>
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                {selectedDocuments.size} Items Selected
              </Typography>

              <Button
                variant="contained"
                style={{
                  borderRadius: "999px",
                  backgroundColor: "#e0f0f7",
                  color: "#1E1450",
                  fontWeight: 600,
                  textTransform: "none",
                  marginLeft: '5px'
                }}
                endIcon={<span style={{ fontSize: "16px" }}>▾</span>}
                onClick={handleBulkMenuClick}
              >
                Bulk Actions
              </Button>

              <Menu
                anchorEl={bulkAnchorEl}
                keepMounted
                open={Boolean(bulkAnchorEl)}
                onClose={handleBulkMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                getContentAnchorEl={null}
              >
                {!isStaging && (
                  <MenuItem onClick={() => downloadFiles(Array.from(selectedDocuments), setBackdrop)}>
                    <DownloadIcon style={{ marginRight: 8 }} fontSize="small" /> Download
                  </MenuItem>
                )}
                {!isStaging && canShare && (
                  <MenuItem onClick={handleShareClick}>
                    <ShareIcon style={{ marginRight: 8 }} fontSize="small" /> Share
                  </MenuItem>
                )}
                {canDelete && (
                  <MenuItem onClick={handleDeleteClick}>
                    <DeleteIcon style={{ marginRight: 8 }} fontSize="small" />
                    Delete
                  </MenuItem>
                )}
                {<MenuItem onClick={handleRetryClick}>
                  <ReplayIcon style={{ marginRight: 8 }} fontSize="small" />
                  Retry 
                </MenuItem>}                

              </Menu>
            </Box>
          ) : (
            <IconButton
              className={classes.iconButton}
              onClick={handleTopMenuClick}
            >
              <MoreVertIcon sx={{ color: "#005B96" }} />
            </IconButton>
          )}



        </Box>
      </Box>
      <div style={{ width: '100%', overflowX: 'auto' }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow className={classes.whiteRow}>
              <TableCell padding="checkbox" align='center'>
                <Checkbox
                  size="small"
                  className={classes.selectAllCheckBox}
                  checked={allPageSelected}
                  indeterminate={somePageSelected}
                  onChange={handleSelectAllPage}
                  inputProps={{
                    'aria-label': 'select all files on this page'
                  }}
                />
              </TableCell>
              {columns.map(column => {
                if (manageColumnsState[column.id]) {
                  return (
                    <TableCell
                      className={classes.boldCell}
                      key={column.id}
                      sortDirection={orderBy === column.id ? order : false}
                    >
                      {column.sortable ? (
                        <TableSortLabel
                          active={orderBy === column.id}
                          direction={order}
                          onClick={handleRequestSort(column.id)}
                          hideSortIcon={false}
                          IconComponent={CustomSortIcon}
                          classes={{
                            root: classes.sortLabel,
                            active: classes.sortLabelActive,
                            icon: classes.sortIcon,
                          }}
                        >
                          {column.label}
                          {orderBy === column.id ? (
                            <span className={classes.visuallyHidden}>
                              {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                          ) : null}
                        </TableSortLabel>
                      ) : (
                        column.label
                      )}
                    </TableCell>);
                }
                return null; // Hide columns that are toggled off
              })}
              <TableCell className={`${classes.boldCell} ${classes.stickyHeaderCell}`} align="right">
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows && rows.length
              ? rows.map((row, index) => {
                return (
                  <TableRow hover role="data-row" key={index} className={index % 2 == 0 ? classes.coloredRow : classes.whiteRow} onClick={() => (onDocumentClick(row))}>
                    <TableCell>
                      {/* <Checkbox /> */}
                      <Checkbox
                        size="small"
                        className={classes.checkBox}
                        checked={selectedDocuments.has(row.id)}
                        onChange={(event) => {
                          const isChecked = event.target.checked;
                          return handleMultipleFileSelect(row.id, isChecked, row.file_identifier, row.name);
                        }}
                      />
                    </TableCell>
                    {columns.map(column => {
                      if (manageColumnsState[column.id]) {
                        let value = row[column.id];

                        // Custom rendering for staging_reason column
                        if (column.id === 'staging_reason') {
                          const causeType = value;
                          if (causeType && STAGING_CAUSE_CONFIG[causeType]) {
                            const config = STAGING_CAUSE_CONFIG[causeType];
                            return (
                              <TableCell className={classes.cell} key={column.id} align={column.align} width={column.width}>
                                <Chip
                                  label={config.label}
                                  size="small"
                                  style={{
                                    backgroundColor: config.chipColor,
                                    color: config.textColor,
                                    fontFamily: "Montserrat",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    lineHeight: "10px",
                                    letterSpacing: 0,
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                    border: "1px solid #AD2F33",
                                    borderRadius: "2px"
                                  }}
                                />
                              </TableCell>
                            );
                          }
                          // Render "Unknown" chip when staging_reason is null
                          return (
                            <TableCell className={classes.cell} key={column.id} align={column.align} width={column.width}>
                              <Chip
                                icon={
                                  <Box
                                    style={{
                                      width: "14px",
                                      height: "14px",
                                      borderRadius: "50%",
                                      backgroundColor: "#FFFFFF",
                                      border: "1px solid #0F0F19",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#0F0F19",
                                      fontSize: "10px",
                                      fontWeight: "bold",
                                      fontFamily: "Arial, sans-serif"
                                    }}
                                  >
                                    i
                                  </Box>
                                }
                                label="Unknown"
                                size="small"
                                style={{
                                  backgroundColor: "#FFFFFF",
                                  color: "#0F0F19",
                                  fontFamily: "Montserrat",
                                  fontWeight: 400,
                                  fontSize: "12px",
                                  lineHeight: "10px",
                                  letterSpacing: 0,
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  border: "1px solid #AD2F33",
                                  borderRadius: "2px"
                                }}
                              />
                            </TableCell>
                          );
                        }

                        if (column.id === "location") {
                          const locationLabel = getRowLocationLabel(row);
                          return (
                            <TableCell className={classes.cell} key={column.id} align={column.align} width={column.width}>
                              {locationLabel === "-" ? (
                                "-"
                              ) : (
                                <span
                                  className={classes.locationLink}
                                  onClick={(event) => handleLocationNavigation(event, row)}
                                  role="button"
                                  tabIndex={0}
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter" || event.key === " ") {
                                      event.preventDefault();
                                      handleLocationNavigation(event, row);
                                    }
                                  }}
                                >
                                  {locationLabel}
                                </span>
                              )}
                            </TableCell>
                          );
                        }

                        if (typeof value == 'boolean') {
                          if (value) {
                            value = 'true'
                          } else {
                            value = 'false'
                          }
                        }
                        return (
                          <TableCell className={classes.cell} key={column.id} align={column.align} width={column.width}>
                            {renderValue(value) || '-'}
                          </TableCell>
                        );
                      }
                      return null;
                    })}

                    <TableCell align="center" className={classes.stickyActionCell}>
                      <IconButton
                        className={classes.iconButton}
                        onClick={(e) => handleMenuClick(e, row)}
                        disabled={selectedDocuments && selectedDocuments.size >= 1}
                      >
                        <MoreVertIcon sx={{ color: "#005B96" }} />
                      </IconButton>
                    </TableCell>

                  </TableRow>
                );
              })
              : createNoTable()}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        rowsPerPageOptions={userPrefs.rowsPerPageOptions}
        component="div"
        count={Number(queryCount)}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        backIconButtonProps={{
          'aria-label': 'previous page'
        }}
        nextIconButtonProps={{
          'aria-label': 'next page'
        }}
        labelRowsPerPage={'Rows per page'}
      />

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        getContentAnchorEl={null}
        disabled={selectedDocuments && selectedDocuments.size >= 1}
      >
        {(() => {
          const allowedActions = selectedActionRow ? getActionsForRow(selectedActionRow) : [];

          const items = [];

          if (allowedActions.includes('rename')) {
            items.push(
              <MenuItem key="rename" onClick={handleRenameClick}>
                <EditIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
                Rename
              </MenuItem>
            );
          }

          if (allowedActions.includes('keep')) {
            items.push(
              <MenuItem key="keep" onClick={handleKeepClick}>
                <CheckIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
                Keep
              </MenuItem>
            );
          }

          if (allowedActions.includes('edit_metadata') && canEdit) {
            items.push(
              <MenuItem key="edit_metadata" onClick={handleEditClick}>
                <EditIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
                Edit Metadata
              </MenuItem>
            );
          }

          if (!isStaging && canShare) {
            items.push(
              <MenuItem key="share" onClick={handleShareClick}>
                <ShareIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
                Share
              </MenuItem>
            );
          }

          if (!isStaging) {
            items.push(
              <MenuItem key="download" onClick={() => { downloadFiles([[selectedActionRow.id, selectedActionRow.name]], setBackdrop); handleMenuClose(); }}>
                <DownloadIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
                Download
              </MenuItem>
            );
          }

          if (allowedActions.includes('delete') && canDelete) {
            items.push(
              <MenuItem key="delete" onClick={handleDeleteClick}>
                <DeleteIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
                Delete
              </MenuItem>
            );
          }

          if (allowedActions.includes('move_to_folder') && canMove) {
            items.push(
              <MenuItem key="move_to_folder" onClick={handleMoveFolderClick}>
                <MoveIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
                Move to Folder
              </MenuItem>
            );
          }

          if (allowedActions.includes('manual_entry') && canEdit) {
            items.push(
              <MenuItem key="manual_entry" onClick={handleManualEntryClick}>
                <EditIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
                Manual Field Entry
              </MenuItem>
            );
          }

          if (allowedActions.includes('manual_classify') && canEdit) {
            items.push(
              <MenuItem key="manual_classify" onClick={handleManualClassifyClick}>
                <EditIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
                Manual Classification
              </MenuItem>
            );
          }
          return items;
        })()}
      </Menu>

      <Menu
        anchorEl={anchorElTop}
        keepMounted
        open={Boolean(anchorElTop)}
        onClose={handleTopMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        getContentAnchorEl={null}
      >
        <MenuItem
          onClick={handleFilterOpen}
        >
          <TuneOutlined className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
          Filters
        </MenuItem>

        <MenuItem
          onClick={handleManageColumnsOpen}
        >
          <SettingsIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
          Manage Columns
        </MenuItem>
      </Menu>



      {(selectedActionRow && <Dialog
        open={openEditModal}
        onClose={handleEditClose}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="h4"
            className={classes.title}
          >
            Edit Document
          </Typography>
        </DialogTitle>
        <DialogContent dividers style={{ height: "80vh" }}>
          <FormControlLabel
            control={
              <Switch
                checked={showSystemFields}
                onChange={() => setShowSystemFields((prev) => !prev)}
                color="primary"
              />
            }
            label="Show System Fields"
          />
          <Grid container spacing={2} style={{ height: "100%" }}>

            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                {documentDetails &&
                  Object.entries(documentDetails).map(([key, value]) => {
                    const isSystemField = systemFields.includes(key);

                    if (showSystemFields && isSystemField) {
                      // Show non-editable system fields (greyed out)
                      return (
                        <Grid item xs={12} md={6} key={key}>
                          <Typography className={classes.fieldName}>
                            {key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}:
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            value={value || ""}
                            disabled
                          />
                        </Grid>
                      );
                    }

                    if (!showSystemFields && !isSystemField) {
                      // Show editable user fields
                      return (
                        <Grid item xs={12} md={6} key={key}>
                          <Typography className={classes.fieldName}>
                            {key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}:
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            value={value || ""}
                            onChange={(e) => handleFieldChange(key, e.target.value)}
                          />
                        </Grid>
                      );
                    }

                    return null; // Hide everything else
                  })}
              </Grid>
            </Grid>




            {/* Right side: PDF preview */}
            <Grid item xs={12} md={6} style={{ height: "100%" }}>
              <Paper
                elevation={3}
                style={{
                  height: "100%",
                  padding: 16,
                  overflow: "auto",
                  background: "#f8f8f8",
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography variant="h6" noWrap>
                    {selectedActionRow.name}
                  </Typography>
                  <IconButton onClick={handleEditClose}>
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Fade in timeout={500}>
                  <div
                    style={{
                      height: "100%",
                      overflow: "auto",
                      padding: 8,
                      background: "#f5f5f5",
                      borderRadius: 4,
                      boxSizing: "border-box",
                    }}
                  >
                    <PDFViewer
                      file={selectedActionRow.id}
                      name={selectedActionRow.name}
                      extension={selectedActionRow.extension}
                    />
                  </div>
                </Fade>
              </Paper>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleEditClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              console.log("Save changes for:", selectedActionRow);
              handleEditSave();
            }}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>


      )}

      <Drawer
        anchor="right"
        open={manageColumnsOpen}
        onClose={handleManageColumnsClose}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Box className={classes.drawerContainer}>
          <Box className={classes.drawerHeader}>
            <Typography
              variant="h4"
              className={classes.drawerTitle}
            >
              Manage Columns
            </Typography>
            <IconButton className={classes.drawerCloseButton} onClick={handleManageColumnsClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider />

          <DragDropContext onDragEnd={onDragEnd}>
            <Box className={classes.drawerContent}>
              {/* Left Panel: Available Columns */}
              <Box className={classes.panel}>
                <Box className={classes.panelHeader}>
                  <Typography className={classes.panelTitleLeft}>Available Columns</Typography>
                </Box>
                <Box className={classes.searchContainer}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="Search Column"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className={classes.searchField}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon className={classes.searchIcon} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <Droppable droppableId="available" type="COLUMN">
                  {(provided, snapshot) => (
                    <Box 
                      className={classes.columnList}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{
                        backgroundColor: snapshot.isDraggingOver ? '#E3F2FD' : 'transparent',
                        transition: 'background-color 0.2s ease',
                      }}
                    >
                      {filteredAvailableColumns.map((col, index) => (
                        <Draggable
                          key={col.id}
                          draggableId={col.id}
                          index={index}
                          isDragDisabled={mandatoryColumns.includes(col.id)}
                        >
                          {(provided, snapshot) => (
                            <Box
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className={`${classes.columnItem} ${classes.availableColumnItem} ${mandatoryColumns.includes(col.id) ? classes.lockedColumnItem : ''} ${snapshot.isDragging ? classes.draggingColumnItem : ''}`}
                              style={{
                                ...provided.draggableProps.style,
                              }}
                            >
                              <Box className={classes.dragHandle}>
                                <img src={dragonIcon} alt="Drag handle" />
                              </Box>
                              <Typography className={classes.columnName}>{col.label}</Typography>
                              {mandatoryColumns.includes(col.id) && (
                                <Box className={classes.lockIcon}>
                                  <img src={lockIcon} alt="Locked" />
                                </Box>
                              )}
                            </Box>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                      {filteredAvailableColumns.length === 0 && (
                        <Typography className={classes.emptyStateText}>
                          No available columns
                        </Typography>
                      )}
                    </Box>
                  )}
                </Droppable>
              </Box>

              {/* Transfer Buttons */}
              <Box className={classes.transferButtons}>
                <Box style={{ position: 'relative', padding: '8px' }}>
                  <img
                    src={vectorImage}
                    alt="Transfer columns"
                    className={classes.transferImage}
                    style={{ width: '21px', height: '20px', objectFit: 'contain' }}
                  />
                </Box>
              </Box>

              {/* Right Panel: In Use */}
              <Box className={classes.panel}>
                <Box className={classes.panelHeader}>
                  <Typography className={classes.panelTitleRight}>In Use</Typography>
                  <Typography className={classes.panelInstructions}>
                    Click and drag to reorder the columns
                  </Typography>
                </Box>
                <Droppable droppableId="inUse" type="COLUMN">
                  {(provided, snapshot) => (
                    <Box 
                      className={classes.columnList}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{
                        backgroundColor: snapshot.isDraggingOver ? '#E3F2FD' : 'transparent',
                        transition: 'background-color 0.2s ease',
                      }}
                    >
                      {inUseColumns.map((col, index) => (
                        <Draggable 
                          key={col.id} 
                          draggableId={`inuse-${col.id}`} 
                          index={index}
                          isDragDisabled={mandatoryColumns.includes(col.id)}
                        >
                          {(provided, snapshot) => (
                            <Box
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className={`${classes.columnItem} ${classes.inUseColumnItem} ${mandatoryColumns.includes(col.id) ? classes.lockedColumnItem : ''} ${snapshot.isDragging ? classes.draggingColumnItem : ''}`}
                              style={{
                                ...provided.draggableProps.style,
                                opacity: mandatoryColumns.includes(col.id) ? 0.8 : 1,
                              }}
                            >
                              <Box className={classes.dragHandle}>
                                <img src={dragonIcon} alt="Drag handle" />
                              </Box>
                              <Typography className={classes.columnName}>{col.label}</Typography>
                              {(col.id === 'name' || mandatoryColumns.includes(col.id)) && (
                                <Box className={classes.lockIcon}>
                                  <img src={lockIcon} alt="Locked" />
                                </Box>
                              )}
                              {col.id !== 'name' && !mandatoryColumns.includes(col.id) && (
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeColumnFromInUse(col);
                                  }}
                                  className={classes.removeIcon}
                                >
                                  <img src={crossIcon} alt="Remove" />
                                </IconButton>
                              )}
                            </Box>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                      {inUseColumns.length === 0 && (
                        <Typography className={classes.emptyStateText}>
                          No columns in use
                        </Typography>
                      )}
                    </Box>
                  )}
                </Droppable>
              </Box>
            </Box>
          </DragDropContext>

          {/* Footer */}
          <Box className={classes.drawerFooter}>
            <Button onClick={handleManageColumnsClose} className={`${classes.drawerButton} ${classes.cancelButton}`}>
              Cancel
            </Button>
            <Box className={classes.footerButtonContainer}>
              <Button onClick={handleResetColumns} className={`${classes.drawerButton} ${classes.resetButton}`}>
                Reset
              </Button>
              <Button onClick={handleSaveView} className={`${classes.drawerButton} ${classes.saveButton}`}>
                Save View
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>

      <Dialog open={filterDialogOpen} onClose={handleFilterClose} maxWidth="md" fullWidth >
        <DialogTitle>
          <Typography variant="h4" className={classes.title}>
            Filter Documents
          </Typography>
        </DialogTitle>
        <DialogContent dividers style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <Grid container spacing={2}>
            {filterKeys.map((col) =>

              <Grid item xs={12} sm={6} md={4} key={col}>
                {Object.keys(filterFormValues).includes(col) ? (
                  <FormControl fullWidth size="small" variant="outlined">
                    <InputLabel>{toTitleCase(col)}</InputLabel>
                    <Select
                      value={filters["_" + col] || ""}
                      onChange={(e) => handleFilterChange("_" + col, e.target.value)}
                      label={toTitleCase(col)}
                    >
                      {filterFormValues[col].map((ext) => (
                        <MenuItem key={ext} value={ext}>
                          {ext}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) :
                  <TextField
                    fullWidth
                    label={col}
                    variant="outlined"
                    size="small"
                    value={filters['_' + col] || ""}
                    onChange={(e) => handleFilterChange('_' + col, e.target.value)}
                  />
                }
              </Grid>

            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFilterClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleFilterApply} color="primary" variant="contained">
            Apply
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={moveModalOpen}
        onClose={() => setMoveModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h5" className={classes.title}>
            Move Document
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <FormControl fullWidth size="small" variant="outlined">
            <InputLabel>Folder Name</InputLabel>
            <Select
              value={selectedDocType}
              onChange={(e) => setSelectedDocType(e.target.value)}
              label="Folder Name"
            >
              {allDocumentTypes?.map((type) => (
                <MenuItem key={type} value={type}>
                  {formatDocName(type)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setMoveModalOpen(false)}
            color="secondary"
            disabled={moveLoading}
          >
            Cancel
          </Button>

          <Button
            onClick={handleConfirmMove}
            color="primary"
            variant="contained"
            disabled={moveLoading}
          >
            {moveLoading ? "Moving..." : "Move"}
          </Button>
        </DialogActions>
      </Dialog>


      <ShareModal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        document={selectedActionRow}
        fileIdentifiers={selectedDocumentsFileId ? Array.from(selectedDocumentsFileId) : []}
      />

      <RecycleBinModal
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        document={selectedActionRow}            // single delete OR
        fileIdentifiers={
          selectedDocuments
            ? Array.from(selectedDocuments.keys())  // extract only IDs
            : []
        }
        loading={false}
        type='delete'
        handleRefresh={refreshPage}
      />

      {/* Manual Field Entry Modal with Document Preview */}
      <Dialog
        open={manualEntryOpen}
        onClose={() => !manualLoading && setManualEntryOpen(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          style: { height: '85vh', maxHeight: '85vh' }
        }}
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" className={classes.title}>
              Manual Field Entry
            </Typography>
            <IconButton 
              size="small" 
              onClick={() => setManualEntryOpen(false)}
              disabled={manualLoading}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography variant="body2" style={{ color: '#666', marginTop: 4 }}>
            Enter field values manually for document: {selectedActionRow?.name}
          </Typography>
        </DialogTitle>

        <DialogContent dividers style={{ padding: 16, overflow: 'hidden' }}>
          <Box className={classes.splitViewContainer}>
            {/* Document Preview Pane */}
            <Box className={classes.documentPreviewPane}>
              <Box className={classes.documentPreviewHeader}>
                <Typography className={classes.documentPreviewTitle}>
                  Document Preview
                </Typography>
              </Box>
              <Box className={classes.documentPreviewContent}>
                {selectedActionRow && (
                  <PDFViewer
                    file={selectedActionRow.id}
                    name={selectedActionRow.name}
                    extension={selectedActionRow.extension || '.pdf'}
                  />
                )}
              </Box>
            </Box>

            {/* Form Fields Pane */}
            <Box className={classes.formPane}>
              <Box className={classes.formPaneHeader}>
                <Typography className={classes.formPaneTitle}>
                  Field Values
                </Typography>
              </Box>
              <Box className={classes.formPaneContent}>
                {documentDetails && (
                  <Grid container spacing={2}>
                    {clientFields.filter(f => !f.parentFieldId && !f.parent_field_id).map((field) => {
                      const fieldKey = field.columnName || field.column_name;
                      const currentValue = documentDetails[fieldKey] || '';
                      return (
                        <Grid item xs={12} key={field.id}>
                          <TextField
                            fullWidth
                            label={field.name}
                            variant="outlined"
                            size="small"
                            value={currentValue}
                            onChange={(e) => handleFieldChange(fieldKey, e.target.value)}
                            disabled={manualLoading}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                )}
              </Box>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setManualEntryOpen(false)}
            color="secondary"
            disabled={manualLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleManualEntrySave}
            color="primary"
            variant="contained"
            disabled={manualLoading}
          >
            {manualLoading ? "Saving..." : "Save & Mark as Manual"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Manual Classification Modal with Document Preview */}
      <Dialog
        open={manualClassifyOpen}
        onClose={() => !manualLoading && setManualClassifyOpen(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          style: { height: '85vh', maxHeight: '85vh' }
        }}
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" className={classes.title}>
              Manual Classification
            </Typography>
            <IconButton 
              size="small" 
              onClick={() => setManualClassifyOpen(false)}
              disabled={manualLoading}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography variant="body2" style={{ color: '#666', marginTop: 4 }}>
            Select a category for document: {selectedActionRow?.name}
          </Typography>
        </DialogTitle>

        <DialogContent dividers style={{ padding: 16, overflow: 'hidden' }}>
          <Box className={classes.splitViewContainer}>
            {/* Document Preview Pane */}
            <Box className={classes.documentPreviewPane}>
              <Box className={classes.documentPreviewHeader}>
                <Typography className={classes.documentPreviewTitle}>
                  Document Preview
                </Typography>
              </Box>
              <Box className={classes.documentPreviewContent}>
                {selectedActionRow && (
                  <PDFViewer
                    file={selectedActionRow.id}
                    name={selectedActionRow.name}
                    extension={selectedActionRow.extension || '.pdf'}
                  />
                )}
              </Box>
            </Box>

            {/* Classification Form Pane */}
            <Box className={classes.formPane}>
              <Box className={classes.formPaneHeader}>
                <Typography className={classes.formPaneTitle}>
                  Select Category
                </Typography>
              </Box>
              <Box className={classes.formPaneContent}>
                <FormControl fullWidth size="small" variant="outlined">
                  <InputLabel>Document Category</InputLabel>
                  <Select
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                    label="Document Category"
                  >
                    {categories.map((cat) => (
                      <MenuItem key={cat.id} value={cat.name}>
                        {cat.name}
                        {cat.description && (
                          <Typography variant="caption" style={{ marginLeft: 8, color: '#666' }}>
                            - {cat.description}
                          </Typography>
                        )}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                
                <Box mt={2} p={2} style={{ backgroundColor: '#FFF8E1', borderRadius: 8 }}>
                  <Typography variant="body2" style={{ color: '#F57C00' }}>
                    <strong>Note:</strong> This will manually set the document category and mark the classification status as "manual".
                  </Typography>
                </Box>

                <Box mt={3} p={2} style={{ backgroundColor: '#E3F2FD', borderRadius: 8 }}>
                  <Typography variant="body2" style={{ color: '#1565C0' }}>
                    <strong>Tip:</strong> Review the document preview on the left to identify the correct category before making your selection.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setManualClassifyOpen(false)}
            color="secondary"
            disabled={manualLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleManualClassifySave}
            color="primary"
            variant="contained"
            disabled={manualLoading || !selectedCategory}
          >
            {manualLoading ? "Saving..." : "Classify Document"}
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default DocumentTabularView;